module.exports = __webpack_public_path__ + "img/ico-linkedin.434f02cd.svg";